import gql from "graphql-tag";

export const SAVE = gql`
  mutation save($data: SaveInput!) {
    save(data: $data)
  }
`;